import React, { useEffect, useState, useContext } from 'react'

import { Header } from '../../components/header/header'
import { NavBar } from '../../components/navBar/navbar'
import { Menu } from '../../components/menu/menu.jsx'
import './styles.css'
import { AuthContext } from '../../contexts/auth'
import { getProjectsCookies, getTasksCookies } from '../../services/updateData'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import LastUpdates from './lastupdates'
import PendencyContainer from './pendencyContainer'
import LoadContainer from '../../components/loading'

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const { logout } = useContext(AuthContext)
	const [lastTasks, setLastTasks] = useState([])

	const handleLastTasks = async (taskArray) => {
		if (taskArray) {
			setLastTasks((prev) => [...prev, taskArray[0]])
		}
	}
	const askForProjects = async () => {
		const newProjects = await getProjectsCookies()
		if (newProjects) {
			await Promise.all(
				newProjects.map((project, index) => {
					askFortasks(project.id)
				})
			)
		}
		return
	}

	const askFortasks = async (id) => {
		const newTasks = await getTasksCookies(id)
		handleLastTasks(newTasks)
	}

	let check = false
	useEffect(() => {
		;(async () => {
			if (!check) {
				check = true
				await askForProjects()
			}
		})()
	}, [])

	const homeBtns = [
		{ title: 'Minha Conta', icon: 'account_circle', url: '/user' },

		{ title: 'Meus Contratos', icon: 'library_books', url: '/contracts' },

		{ title: 'Acompanhar Atividades', icon: 'view_list', url: '/tasks' },

		{ title: 'Nova Demanda', icon: 'add_task', url: '/order' },

		{ title: 'Fale Conosco', icon: 'headset_mic', url: '/chat' },

		{ title: 'Desconectar', icon: 'logout', url: '' },
	]

	return (
		<div id="home">
			<Menu></Menu>
			<NavBar></NavBar>
			<div className="home-column">
				<Header></Header>
				<div className="info-container">
					<h1 className="home-title">Central do Cliente</h1>
					<div className="blocks-container">
						{homeBtns.map((block, index) => (
							<Link
								key={index}
								className={block.title === 'Desconectar' ? 'home-block logout' : 'home-block'}
								to={block.title === 'Desconectar' ? '' : block.url}
								onClick={block.title === 'Desconectar' ? logout : null}
							>
								<span className="block-title home-icon material-symbols-outlined">{block.icon}</span>
								<span className="block-content">{block.title}</span>
							</Link>
						))}
					</div>
					<h2 className="updates-title">Últimas atualizações:</h2>
					<Link to="/user" className="updatesLink">
						<PendencyContainer />
					</Link>
					<Link to="/tasks" className="updatesLink">
						<div className="updatesContainer">
							{lastTasks
								? lastTasks?.map((update, index) => <LastUpdates key={index} task={update} />)
								: ''}
						</div>
					</Link>
					{isLoading ? <LoadContainer /> : ''}
				</div>
			</div>
		</div>
	)
}

export default Home
